export function CountdownRing({ secondsLeft, total }: { secondsLeft: number | null; total: number }) {
  const size = 56;
  const stroke = 4;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = secondsLeft == null ? 0 : secondsLeft / total;
  const offset = c * (1 - pct);
  const urgent = secondsLeft !== null && secondsLeft <= 5;

  return (
    <div className="relative inline-flex items-center justify-center">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(148,163,184,0.2)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={urgent ? '#ef4444' : '#10b981'}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.25s linear, stroke 0.2s' }}
        />
      </svg>
      <div className={`absolute font-bold ${urgent ? 'text-red-400 animate-pulse' : 'text-slate-100'}`}>
        {secondsLeft ?? '--'}
      </div>
    </div>
  );
}
